export const LOGIN_2FA_PENDING_KEY = "hr_login_2fa_pending";

export function readLoginTwoFactorPendingState() {
  try {
    const raw = sessionStorage.getItem(LOGIN_2FA_PENDING_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeLoginTwoFactorPendingState(nextState) {
  sessionStorage.setItem(LOGIN_2FA_PENDING_KEY, JSON.stringify(nextState));
}

export function clearLoginTwoFactorPendingState() {
  sessionStorage.removeItem(LOGIN_2FA_PENDING_KEY);
}

export function secondsUntilResend(value) {
  if (!value) return 0;
  const target = new Date(value).getTime();
  if (!Number.isFinite(target)) return 0;
  return Math.max(0, Math.ceil((target - Date.now()) / 1000));
}

export function mergeLoginTwoFactorPendingState(current, patch) {
  return {
    ...(current || {}),
    ...(patch || {}),
  };
}
